import { render, staticRenderFns } from "./StudioCom.vue?vue&type=template&id=585a6337&scoped=true"
import script from "./StudioCom.vue?vue&type=script&lang=js"
export * from "./StudioCom.vue?vue&type=script&lang=js"
import style0 from "./StudioCom.vue?vue&type=style&index=0&id=585a6337&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a6337",
  null
  
)

export default component.exports